
import { DetailsList, HoverCard, HoverCardType, IColumn, Icon, IconButton, IHoverCard, Label, Link as FluentLink, Link, SelectionMode, Stack, TooltipHost } from '@fluentui/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/njit-logo.png";
import { isCanvasStudent, sendApiRequest, thisIsDevEnvironment } from '../../lib/helper';
import { useAuthenticationContext } from '../../providers/authenticationprovider';
import { ICourse } from '../../types/ICourse';
import FRPAControl from '../application/frpaControl';

function TopNav() {

    const authContext = useAuthenticationContext();
    const navigate = useNavigate();
    const hoverCard = React.useRef<IHoverCard>(null);
    const [showPrivacySettings, setShowPrivacySettings] = useState<boolean>(false);

    const getCurrentUserCoursesItems = (): Partial<ICourse>[] | undefined => {
        return authContext.Result?.Courses?.filter(c => isNaN(Number(c.Semester))).sort((a, b) => {
            let retVal = -1;
            if (a.Year === b.Year) {
                if (a.Semester === "Fall" && (b.Semester === "Summer" || b.Semester === "Spring")) {
                    retVal = -1;
                }
                else if (a.Semester === "Summer" && b.Semester === "Spring") {
                    retVal = -1;
                }
                else if (a.Semester === b.Semester) {
                    return a.Title < b.Title ? -1 : 1;
                }
                else {
                    retVal = 1;
                }
            }
            else {
                return a.Year < b.Year ? 1 : -1
            }
            return retVal;
        });
    }

    const getCoursesColumns = (): IColumn[] => {
        let retVal: IColumn[] = [{
            key: "Title",
            minWidth: 200,
            name: "Title",
            fieldName: "Title",
            isMultiline: true,
            onRender: (course: ICourse) => {
                return <Link title={`${course.Title} - ${course.Semester} ${course.Year}`} onClick={() => {
                    navigate(`/courses/${course.Year}/${course.Semester}/${encodeURIComponent(course.SIS)}`);
                }}>{course.Title}</Link>
            }
        },
        {
            key: "Semester",
            minWidth: 150,
            name: "Semester",
            fieldName: "Semester",
            onRender: (course: ICourse) => {
                return `${course.Semester} ${course.Year}`
            }
        }];

        return retVal;
    }

    return <header className="App-header">
        <Stack horizontal tokens={{ childrenGap: 10 }}>
            <Stack.Item grow>
                <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
                    <Stack.Item align="start"><img className="logo" src={logo} alt="NJIT Logo" /></Stack.Item>
                    <Stack.Item><div style={{ cursor: "pointer" }} onClick={() => {
                        navigate("/")
                    }} className='app-title'>Kepler 5 - A transparent coursework review system</div></Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item align='end'>
                <Stack horizontal>
                    {authContext.Result?.IsAuthenticated && <Stack horizontal>
                        {authContext.Result.UserInfo && <Stack.Item>
                            <Stack horizontal horizontalAlign="center" verticalAlign="center">
                                <span className='app-title'>Welcome {authContext.Result.UserInfo.DisplayName}</span>
                                <HoverCard
                                    instantOpenOnClick={true}
                                    cardOpenDelay={2000}                           
                                    type={HoverCardType.plain}
                                    cardDismissDelay={1000}
                                    sticky={true}
                                    componentRef={hoverCard}
                                    plainCardProps={{
                                        onRenderPlainCard: () => {
                                            return <div style={{ padding: 10 }}>
                                                <Stack>
                                                    <Stack.Item grow>
                                                        <Stack horizontal grow style={{ justifyContent: "space-between" }}>
                                                            <FluentLink onClick={() => {
                                                                sendApiRequest("/api/logout", "GET").then(res => {
                                                                    window.location.href = "/"
                                                                })
                                                            }}>
                                                                <Stack horizontal>
                                                                    <span>Sign out</span>
                                                                    <Icon iconName='SignOut' style={{ marginLeft: 8, height: 24, lineHeight: "24px" }} />
                                                                </Stack>
                                                            </FluentLink>
                                                            <Stack.Item align="end">
                                                                <IconButton iconProps={{ iconName: "Cancel" }} onClick={() => {
                                                                    if (hoverCard.current) {
                                                                        hoverCard.current.dismiss();
                                                                    }
                                                                }} style={{ marginLeft: 8, height: 24, lineHeight: "24px" }} />
                                                            </Stack.Item>
                                                        </Stack>

                                                    </Stack.Item>
                                                    {(thisIsDevEnvironment || isCanvasStudent(authContext.Result!)) && <Link onClick={() => {
                                                        setShowPrivacySettings(true)
                                                    }}>
                                                        <Stack horizontal>
                                                            <Stack.Item>Permissions to Share Settings</Stack.Item>                                                            
                                                            <Icon iconName='BlockedSite' style={{ marginLeft: 8, height: 24, lineHeight: "24px" }} />
                                                        </Stack>
                                                    </Link>}
                                                    {authContext.Result?.Courses && authContext.Result.Courses.length > 0 ? <Stack.Item>
                                                        <Label>{isCanvasStudent(authContext.Result) ? "Enrolled" : "Teaching"} Courses</Label>
                                                        <DetailsList selectionMode={SelectionMode.none} items={getCurrentUserCoursesItems() || []} columns={getCoursesColumns()} />
                                                    </Stack.Item> : <></>}
                                                </Stack>

                                            </div>
                                        }
                                    }}>
                                    <TooltipHost content={authContext.Result.UserInfo.NoCompanyName ? "The current user does not have the 'companyName' property completed on the Azure AD profile. Please contact an administrator." : undefined}>
                                        <Icon styles={{ root: { color: "white", cursor: "pointer" } }} iconName='ChevronDown' />
                                    </TooltipHost>
                                </HoverCard>
                            </Stack>
                        </Stack.Item>}
                        {showPrivacySettings && <FRPAControl onDismiss={() => setShowPrivacySettings(false)} />}
                    </Stack>}
                </Stack>
            </Stack.Item>
        </Stack>
    </header>
}

export default TopNav;